import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      setAuth: (user, token) => set({ user, token, isAuthenticated: true }),

      logout: () => {
        set({ user: null, token: null, isAuthenticated: false });
        localStorage.removeItem('auth-storage');
        localStorage.removeItem('roadmap-storage');
        
        // Reset roadmap store (will be imported dynamically to avoid circular deps)
        if (typeof window !== 'undefined') {
          window.location.reload(); // Simple way to reset all stores
        }
      },

      updateUser: (userData) => set((state) => ({
        user: { ...state.user, ...userData }
      })),

      getAuthHeader: () => {
        const token = get().token;
        return token ? { Authorization: `Bearer ${token}` } : {};
      }
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useAuthStore;
